import React from 'react'
import type { Track } from 'types/track'
import TrackArtwork from 'components/common/tracks/track-artwork'
import TextOverflow from 'components/ui/text-overflow'
import styles from './index.module.css'

type Props = {
  track: Track
}

/**
 * Simple track name display component with artwork and text overflow handling
 * Shows track artwork alongside track name with ellipsis truncation
 * @param track - Track data containing name and artwork information
 */
const TrackName = ({ track }: Props) => {
  return (
    <div className={styles.trackName}>
      <TrackArtwork baseClassName={styles.trackNameArtwork} track={track} />
      <div className={styles.trackNameCaption}>
        <TextOverflow content={track.name} />
      </div>
    </div>
  )
}

export default React.memo<Props>(TrackName)
